import { brandPrimaryHover, darkGrayFontColor, titles } from '../../../../web/styles/colors';
import { CssSelectors } from '../../../../web/styles/styles';
import * as tableStyles from '../IntegrationsManageUsersTable/styles';
import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	addUserButton: {
		alignItems: 'center',
		color: brandPrimaryHover,
		display: 'flex',
		fontSize: 14,
		justifyContent: 'center',
		width: '100%',
		...CssSelectors.allChildren(
			{
				marginLeft: 10,
			},
			':not(:first-child)'
		),
	},
	addUserDropdownFooter: {
		borderTop: '1px #D8D8D8 solid',
		boxSizing: 'border-box',
		padding: '8px 20px',
	},
	assignedStatusCell: {
		width: tableStyles.ManageUsersTableAssignmentColumnWidth,
	},
	cell: {
		borderBottom: tableStyles.ManageUsersTableCellBorder,
		padding: '20px 10px 20px 0',
	},
	container: {},
	emailColumnCell: {
		minWidth: tableStyles.ManageUsersTableEmailColumnWidth,
		width: tableStyles.ManageUsersTableEmailColumnWidth,
	},
	emailColumnInputs: {
		alignItems: 'center',
		display: 'flex',
		...CssSelectors.allChildren(
			{
				marginLeft: 10,
			},
			':not(:first-child)'
		),
	},
	initialsColumnCell: {
		minWidth: tableStyles.ManageUsersTableInitialsColumnWidth,
		width: tableStyles.ManageUsersTableInitialsColumnWidth,
	},
	status: {
		color: darkGrayFontColor,
		fontSize: 12,
		...CssSelectors.allChildren(
			{
				marginLeft: 10,
			},
			':not(:first-child)'
		),
	},
	statusColumnCell: {
		minWidth: tableStyles.ManageUsersTableStatusColumnWidth,
		width: tableStyles.ManageUsersTableStatusColumnWidth,
	},
	statusConnect: {
		color: titles,
	},
	statusIndicatorColumnCell: {
		minWidth: tableStyles.ManageUsersTableStatusIndicatorColumnWidth,
		width: tableStyles.ManageUsersTableStatusIndicatorColumnWidth,
	},
	statusIndicatorInactive: {
		opacity: 0.5,
	},
});
